export const MOCK_ORDERS = [
  {
    id: "ORD-2024-001",
    order_number: "ORD-2024-001",
    created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(), // 2 days ago
    status: "delivered",
    total: 1250,
    items: [
      { id: 1, name: "Fresh A2 Milk", quantity: 2, price: 150, image: "https://kkisanfresh.thecanatech.com/storage/app/public/product/2023-10-12-6527ba7e0a8d3.png" },
      { id: 2, name: "Organic Cow Ghee", quantity: 1, price: 950, image: "https://kkisanfresh.thecanatech.com/storage/app/public/product/2023-10-12-6527ba7e0a8d3.png" }
    ],
    shipping_address: {
      fullName: "Omkar Bhondve",
      addressLine1: "123, Green Valley Apt",
      addressLine2: "Sector 45",
      city: "Gurgaon",
      state: "Haryana",
      pincode: "122003",
      phone: "+91 9988665522"
    },
    payment_method: "Online Payment",
    subtotal: 1100,
    delivery_charge: 100,
    tax: 50
  },
  {
    id: "ORD-2024-002",
    order_number: "ORD-2024-002",
    created_at: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(), // 5 hours ago
    status: "processing",
    total: 480,
    items: [
      { id: 3, name: "Fresh Paneer", quantity: 2, price: 240, image: "https://kkisanfresh.thecanatech.com/storage/app/public/product/2023-10-12-6527ba7e0a8d3.png" }
    ],
    shipping_address: {
      fullName: "Omkar Bhondve",
      addressLine1: "B-402, Sunshine Residency",
      addressLine2: "Powai",
      city: "Pune",
      state: "Maharashtra",
      pincode: "400076",
      phone: "+91 9988665522"
    },
    payment_method: "Cash on Delivery",
    subtotal: 480,
    delivery_charge: 0,
    tax: 0
  },
  {
    id: "ORD-2024-003",
    order_number: "ORD-2024-003",
    created_at: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(), // 1 day ago
    status: "shipped",
    total: 820,
    items: [
      { id: 4, name: "Greek Yogurt", quantity: 4, price: 205, image: "https://kkisanfresh.thecanatech.com/storage/app/public/product/2023-10-12-6527ba7e0a8d3.png" }
    ],
    shipping_address: {
      fullName: "Omkar Bhondve",
      addressLine1: "Flat 101, Royal Gardens",
      addressLine2: "Banjara Hills",
      city: "Hyderabad",
      state: "Telangana",
      pincode: "500034",
      phone: "+91 9988665522"
    },
    payment_method: "Online Payment",
    subtotal: 820,
    delivery_charge: 0,
    tax: 0
  }
];
